export function lockDocument(dialog: HTMLElement): () => void {
    const html = document.documentElement;
    const prevOverflow = html.style.overflow;
    const prevPaddingRight = html.style.paddingRight;
    const scrollbarGap = window.innerWidth - html.clientWidth;
    html.style.overflow = "hidden";
    if (scrollbarGap > 0) html.style.paddingRight = `${scrollbarGap}px`;

    const opener = document.activeElement;
    const inerted: HTMLElement[] = [];
    for (const el of document.body.children) {
        if (el !== dialog && el instanceof HTMLElement && !el.inert) {
            el.inert = true;
            inerted.push(el);
        }
    }

    return () => {
        html.style.overflow = prevOverflow;
        html.style.paddingRight = prevPaddingRight;
        for (const el of inerted) el.inert = false;
        if (opener instanceof HTMLElement && opener.isConnected) opener.focus();
    };
}
